import React, { useState } from "react";
import { useLocation } from "react-router";
import { Link } from "react-router-dom";
import { Icon } from "rsuite";
import { MainPageLayoutStyle } from "./MainPageLayotStyle.styled";
import Navbar from "./Navbar";

function MainPageLayout({ children }) {
  const location = useLocation();
  const [navOpen, setNavOpen] = useState(false);

  return (
    <MainPageLayoutStyle>
      <Navbar />
      {children}

      <div className="navLinkWrapper">
        <ul
          className="navLinks"
          style={{
            height: `${navOpen ? "100px" : "0px"}`,
            visibility: `${navOpen ? "visible" : "hidden"}`,
          }}
        >
          <Link to="/" className={location.pathname === "/" ? "active" : ""}>
            Home
          </Link>
          <Link
            to="/albums"
            className={location.pathname.includes("/albums") ? "active" : ""}
          >
            Albums
          </Link>
        </ul>
        <button className="toggleBtn" onClick={() => setNavOpen((pre) => !pre)}>
          {navOpen ? (
            <Icon icon="close" size="2x" />
          ) : (
            <Icon icon="bars" size="2x" />
          )}
        </button>
      </div>
    </MainPageLayoutStyle>
  );
}

export default MainPageLayout;
